import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { PencilSimple } from "@phosphor-icons/react";

const fmt = (iso) => new Date(iso).toLocaleString([], { dateStyle: "medium", timeStyle: "short" });

export default function RecentCorrections() {
  const [items, setItems] = useState(null);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    api.get("/transactions", { params: { type: "correction" } }).then((r) => setItems(r.data || [])).catch(() => setItems([]));
  }, []);

  return (
    <>
      <PageHeader title="Stock Corrections" subtitle={items ? `${items.length} correction${items.length === 1 ? "" : "s"} recorded` : "Loading…"} />
      <div className="p-4 sm:p-8">
        <div className="bg-white border border-zinc-300">
          <div className="flex items-center gap-2 px-6 py-4 border-b border-zinc-300 bg-zinc-50">
            <PencilSimple size={18} weight="bold" className="text-primary" />
            <h3 className="font-heading font-bold uppercase tracking-tight text-sm">Complete Correction History</h3>
          </div>
          {items === null ? (
            <p className="p-6 text-sm text-zinc-400">Loading…</p>
          ) : items.length === 0 ? (
            <p className="p-6 text-sm text-zinc-400" data-testid="corrections-empty">No stock corrections yet.</p>
          ) : (
            <div className="divide-y divide-zinc-200" data-testid="corrections-full-list">
              {items.map((t) => (
                <div key={t.id} className="px-6 py-3" data-testid={`correction-full-${t.id}`}>
                  <div className="flex items-center justify-between">
                    <p className="text-sm font-medium text-zinc-900">{t.material_name}</p>
                    <span className={`font-mono text-sm tabular ${t.change >= 0 ? "text-[#16A34A]" : "text-[#DC2626]"}`}>
                      {t.change >= 0 ? "+" : ""}{t.change} {t.unit}
                    </span>
                  </div>
                  {t.reason && <p className="text-xs text-zinc-500 mt-0.5">{t.reason}</p>}
                  <p className="text-[11px] text-zinc-400 mt-0.5">{t.by_name} · {fmt(t.created_at)}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
